
<script setup>

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

</script>

<template>

  <div class="flex items-center justify-center relative">

    <div class="max-w-xl p-6">

      <p class="leading-7 text-white drop-shadow-[0_0_5px_rgba(0,0,0,1)]">

        Shenandoah National Park was established in 1935.
        
        At the time, Virginia was a "Jim Crow" state with laws that legalized racial segregation.
        
        By 1940, a segregated area that included a campground, picnic area, lodge, and cabins was developed at Lewis Mountain.

      </p>

      <p class="mt-6 leading-7 text-white drop-shadow-[0_0_5px_rgba(0,0,0,1)]">

        Through a series of videos and activities, you will explore and discuss the complex story of the park's segregation and desegregation,
        
        and investigate the perspectives of those affected.

      </p>

      <div class="flex justify-center mt-12">

        <RouterLink
        
          class="flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
        
            hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
        
          to="/activities">

          <span>Continue</span>

          <ArrowRightCircleIcon class="w-8" />

        </RouterLink>

      </div>

    </div>

  </div>

</template>
